import { makeModel } from "./crudModel";
export const users = makeModel("users");
export { default as sso } from "./ssoModel";
